<!-- FREEFORM COMPONENT - is not connected to control, we get result by emmiting value outside -->

<mat-form-field [ngClass]="{ 'w-100': true, mgn: isReadonly, 'text-box-freeform': true }" [class.error-input]="errorMessage">
  @if (helpText) {
    <app-help-text [dataContext]="helpText"></app-help-text>
  }
  <input
    matInput
    autocomplete="off"
    [placeholder]="caption | translate"
    [required]="required ? true : null"
    [readonly]="isReadonly ? true : null"
    [class.text-center]="textAlignCenter"
    [value]="value"
    (input)="onTextChange($event)"
    #input
    />
    @if (errorMessage) {
      <mat-hint class="error-message">{{ errorMessage | translate }}</mat-hint>
    }
  </mat-form-field>
